// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';

//Contact Module const
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';

//Auth const
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_GOOGLE_USER = 'SIGNIN_GOOGLE_USER';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'SIGNIN_GOOGLE_USER_SUCCESS';
export const SIGNIN_FACEBOOK_USER = 'SIGNIN_FACEBOOK_USER';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'SIGNIN_FACEBOOK_USER_SUCCESS';
export const SIGNIN_TWITTER_USER = 'SIGNIN_TWITTER_USER';
export const SIGNIN_TWITTER_USER_SUCCESS = 'SIGNIN_TWITTER_USER_SUCCESS';
export const SIGNIN_GITHUB_USER = 'SIGNIN_GITHUB_USER';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_success';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const INIT_URL = 'INIT_URL';
export const REFRESHTOKEN_USER = 'REFRESHTOKEN_USER';
export const REFRESHTOKEN_USER_INTERVAL = 'REFRESHTOKEN_USER_INTERVAL';
export const REFRESHTOKEN_USER_SUCCESS = 'REFRESHTOKEN_USER_SUCCESS';
export const CHANGEPASSWORD = 'CHANGEPASSWORD';
export const CHANGEPASSWORD_SUCCESS = 'CHANGEPASSWORD_SUCCESS';
export const FORGOTPASSWORD = 'FORGOTPASSWORD';
export const FORGOTPASSWORD_SUCCESS = 'FORGOTPASSWORD_SUCCESS';
export const CONFIRMFORGOTPASSWORD = 'CONFIRMFORGOTPASSWORD';
export const CONFIRMFORGOTPASSWORD_SUCCESS = 'CONFIRMFORGOTPASSWORD_SUCCESS';
export const UPDATEACCOUNT = 'UPDATEACCOUNT';
export const UPDATEACCOUNT_SUCCESS = 'UPDATEACCOUNT_SUCCESS';
export const DELETEACCOUNT = 'DELETEACCOUNT';
export const DELETEACCOUNT_SUCCESS = 'DELETEACCOUNT_SUCCESS';
export const ENABLEACCOUNT = 'ENABLEACCOUNT';
export const ENABLEACCOUNT_SUCCESS = 'ENABLEACCOUNT_SUCCESS';
export const DISABLEACCOUNT = 'DISABLEACCOUNT';
export const DISABLEACCOUNT_SUCCESS = 'DISABLEACCOUNT_SUCCESS';
export const CHECKTYPE_USER = 'CHECKTYPE_USER';
export const CHECKTYPE_USER_SUCCESS = 'CHECKTYPE_USER_SUCCESS';
export const GETACCOUNT = 'GETACCOUNT';
export const GETACCOUNT_SUCCESS = 'GETACCOUNT_SUCCESS';

//Sticky
export const GET_STICKY = 'GET_STICKY';
export const NOTES_UPDATE='NOTES_UPDATE';
export const FETCH_ALL_NOTES_SUCCESS='FETCH_ALL_NOTES_SUCCESS';
export const UPDATE_ALL_NOTES_SUCCESS='UPDATE_ALL_NOTES_SUCCESS';

//Contact
export const GET_All_CONTACT_SUCCESS = 'GET_All_CONTACT_SUCCESS';
export const ON_ADD_CONTACT_SUCCESS = 'ON_ADD_CONTACT_SUCCESS';
export const UPDATE_CONTACT_SUCCESS='UPDATE_CONTACT_SUCCESS';
export const DELETE_CONTACT_SUCCESS='DELETE_CONTACT_SUCCESS';

//Application
export const APPINFO = 'APPINFO';
export const APPINFO_SUCCESS = 'APPINFO_SUCCESS';
export const DASHBOARDAPPINFO = 'DASHBOARDAPPINFO';
export const DASHBOARDAPPINFO_SUCCESS = 'DASHBOARDAPPINFO_SUCCESS';
export const DASHBOARDAPPINFOBYTIME = 'DASHBOARDAPPINFOBYTIME';
export const DASHBOARDAPPINFOBYTIME_SUCCESS = 'DASHBOARDAPPINFOBYTIME_SUCCESS';
export const UPDATEAPPLICATION = 'UPDATEAPPLICATION';
export const UPDATEAPPLICATION_SUCCESS = 'UPDATEAPPLICATION_SUCCESS';
export const CREATEAPPLICATION = 'CREATEAPPLICATION';
export const CREATEAPPLICATION_SUCCESS = 'CREATEAPPLICATION_SUCCESS';
export const LOADAPPLICATION = 'LOADAPPLICATION';
export const CLEARAPPLICATIONS = 'CLEARAPPLICATIONS';
export const FETCHSUBKEYS = 'FETCHSUBKEYS';
export const FETCHSUBKEYS_SUCCESS = 'FETCHSUBKEYS_SUCCESS';
export const GENERATESUBKEY = 'GENERATESUBKEY';
export const GENERATESUBKEY_SUCCESS = 'GENERATESUBKEY_SUCCESS';
export const DELETESUBKEY = 'GETSUBKEYS';
export const DELETESUBKEY_SUCCESS = 'GETSUBKEYS_SUCCESS';
export const GENERATEKEY = 'GENERATEKEY';
export const GENERATEKEY_SUCCESS = 'GENERATEKEY_SUCCESS';


//Device
export const FETCHIBEACONS = 'FETCHIBEACONS';
export const FETCHEDDYSTONES = 'FETCHEDDYSTONES';
export const FETCHREADERS = 'FETCHREADERS';
export const FETCHHUBS = 'FETCHHUBS';
export const FETCHGATEWAYS = 'FETCHGATEWAYS';
export const FETCHSENSORS = 'FETCHSENSORS';
export const FETCHNFCTAGS = 'FETCHNFCTAGS';
export const FETCHNFCTAGSCONNECTION = 'FETCHNFCTAGSCONNECTION';
export const FETCHLIGHTINGS = 'FETCHLIGHTINGS';
export const FETCHIBEACONS_SUCCESS = 'FETCHIBEACONS_SUCCESS';
export const FETCHEDDYSTONES_SUCCESS = 'FETCHEDDYSTONES_SUCCESS';
export const FETCHREADERS_SUCCESS = 'FETCHREADERS_SUCCESS';
export const FETCHHUBS_SUCCESS = 'FETCHHUBS_SUCCESS';
export const FETCHGATEWAYS_SUCCESS = 'FETCHGATEWAYS_SUCCESS';
export const FETCHSENSORS_SUCCESS = 'FETCHSENSORS_SUCCESS';
export const FETCHNFCTAGS_SUCCESS = 'FETCHNFCTAGS_SUCCESS';
export const FETCHNFCTAGSCONNECTION_SUCCESS = 'FETCHNFCTAGSCONNECTON_SUCCESS';
export const FETCHLIGHTINGS_SUCCESS = 'FETCHLIGHTINGS_SUCCESS';
export const FETCHIBEACON = 'FETCHIBEACON';
export const FETCHEDDYSTONE = 'FETCHEDDYSTONE';
export const FETCHREADER = 'FETCHREADER';
export const FETCHHUB = 'FETCHHUB';
export const FETCHGATEWAY = 'FETCHGATEWAY';
export const FETCHDEVICELOGS = 'FETCHDEVICELOGS';
export const FETCHWIFITESTS = 'FETCHWIFITESTS';
export const COUNTNFCTAGSLATLNG = 'COUNTNFCTAGSLATLNG';
export const COUNTSERIALRANGE = 'COUNTSERIALRANGE';
export const COUNTSERIALRANGE_SUCCESS = 'COUNTSERIALRANGE_SUCCESS';
export const GETSERIALRANGE = 'GETSERIALRANGE';
export const GETSERIALRANGE_SUCCESS = 'GETSERIALRANGE_SUCCESS';
export const FETCHIBEACON_SUCCESS = 'FETCHIBEACON_SUCCESS';
export const FETCHEDDYSTONE_SUCCESS = 'FETCHEDDYSTONE_SUCCESS';
export const FETCHREADER_SUCCESS = 'FETCHREADER_SUCCESS';
export const FETCHHUB_SUCCESS = 'FETCHHUB_SUCCESS';
export const FETCHGATEWAY_SUCCESS = 'FETCHGATEWAY_SUCCESS';
export const FETCHDEVICELOGS_SUCCESS = 'FETCHDEVICELOGS_SUCCESS';
export const FETCHWIFITESTS_SUCCESS = 'FETCHWIFITESTS_SUCCESS';
export const COUNTNFCTAGSLATLNG_SUCCESS = 'COUNTNFCTAGSLATLNG_SUCCESS';

export const CREATEDEVICE = 'CREATEDEVICE';
export const CREATEIBEACON = 'CREATEIBEACON';
export const CREATEEDDYSTONE = 'CREATEEDDYSTONE';
export const CREATEREADER = 'CREATEREADER';
export const CREATEHUB = 'CREATEHUB';
export const CREATEGATEWAY = 'CREATEGATEWAY';
export const CREATEDEVICES = 'CREATEDEVICES';
export const CREATEDEVICESPARALLEL = 'CREATEDEVICESPARALLEL';
export const CREATEMESHELEMENT = 'CREATEMESHELEMENT';
export const CREATEDEVICE_SUCCESS = 'CREATEDEVICE_SUCCESS';
export const CREATEIBEACON_SUCCESS = 'CREATEIBEACON_SUCCESS';
export const CREATEEDDYSTONE_SUCCESS = 'CREATEEDDYSTONE_SUCCESS';
export const CREATEREADER_SUCCESS = 'CREATEREADER_SUCCESS';
export const CREATEHUB_SUCCESS = 'CREATEHUB_SUCCESS';
export const CREATEGATEWAY_SUCCESS = 'CREATEGATEWAY_SUCCESS';
export const CREATEDEVICES_SUCCESS = 'CREATEDEVICES_SUCCESS';
export const CREATEDEVICESPARALLEL_SUCCESS = 'CREATEDEVICESPARALLEL_SUCCESS';
export const CREATEMESHELEMENT_SUCCESS = 'CREATEMESHELEMENT_SUCCESS';

export const UPDATEDEVICE = 'UPDATEDEVICE';
export const UPDATEIBEACON = 'UPDATEIBEACON';
export const UPDATEEDDYSTONE = 'UPDATEEDDYSTONE';
export const UPDATEREADER = 'UPDATEREADER';
export const UPDATEHUB = 'UPDATEHUB';
export const UPDATEGATEWAY = 'UPDATEGATEWAY';
export const UPDATESHADOW = 'UPDATESHADOW';
export const UPDATEMESHELEMENT = 'UPDATEMESHELEMENT';
export const OTAUPDATE = 'OTAUPDATE';
export const UPDATEDEVICE_SUCCESS = 'UPDATEDEVICE_SUCCESS';
export const UPDATEIBEACON_SUCCESS = 'UPDATEIBEACON_SUCCESS';
export const UPDATEEDDYSTONE_SUCCESS = 'UPDATEEDDYSTONE_SUCCESS';
export const UPDATEREADER_SUCCESS = 'UPDATEREADER_SUCCESS';
export const UPDATEHUB_SUCCESS = 'UPDATEHUB_SUCCESS';
export const UPDATEGATEWAY_SUCCESS = 'UPDATEGATEWAY_SUCCESS';
export const UPDATESHADOW_SUCCESS = 'UPDATESHADOW_SUCCESS';
export const OTAUPDATE_SUCCESS = 'OTAUPDATE_SUCCESS';
export const UPDATEMESHELEMENT_SUCCESS = 'UPDATEMESHELEMENT_SUCCESS';

export const DELETEDEVICE = 'DELETEDEVICE';
export const DELETEIBEACON = 'DELETEIBEACON';
export const DELETEEDDYSTONE = 'DELETEEDDYSTONE';
export const DELETEREADER = 'DELETEREADER';
export const DELETEHUB = 'DELETEHUB';
export const DELETEGATEWAY = 'DELETEGATEWAY';
export const DELETEDEVICES = 'DELETEDEVICES';
export const DELETEMESHELEMENT = 'DELETEMESHELEMENT';
export const DELETEDEVICE_SUCCESS = 'DELETEDEVICE_SUCCESS';
export const DELETEIBEACON_SUCCESS = 'DELETEIBEACON_SUCCESS';
export const DELETEEDDYSTONE_SUCCESS = 'DELETEEDDYSTONE_SUCCESS';
export const DELETEREADER_SUCCESS = 'DELETEREADER_SUCCESS';
export const DELETEHUB_SUCCESS = 'DELETEHUB_SUCCESS';
export const DELETEGATEWAY_SUCCESS = 'DELETEGATEWAY_SUCCESS';
export const DELETEDEVICES_SUCCESS = 'DELETEDEVICES_SUCCESS';
export const DELETEMESHELEMENT_SUCCESS = 'DELETEMESHELEMENT_SUCCESS';

export const VALIDATEDEVICES = 'VALIDATEDEVICES';
export const VALIDATEDEVICES_SUCCESS = 'VALIDATEDEVICES_SUCCESS';

export const OPENBUZZVOXLOCK = 'OPENBUZZVOXLOCK';
export const OPENBUZZVOXLOCK_SUCCESS = 'OPENBUZZVOXLOCK_SUCCESS';

// Minisite
export const FETCHADVERTISEMENTS = 'FETCHADVERTISEMENTS';
export const FETCHCOUPONS = 'FETCHCOUPONS';
export const FETCHVOTINGS = 'FETCHVOTINGS';
export const FETCHPOLLINGS = 'FETCHPOLLINGS';
export const FETCHDEEPLINKS = 'FETCHDEEPLINKS';
export const FETCHADVERTISEMENTS_SUCCESS = 'FETCHADVERTISEMENTS_SUCCESS';
export const FETCHCOUPONS_SUCCESS = 'FETCHCOUPONS_SUCCESS';
export const FETCHVOTINGS_SUCCESS = 'FETCHVOTINGS_SUCCESS';
export const FETCHPOLLINGS_SUCCESS = 'FETCHPOLLINGS_SUCCESS';
export const FETCHDEEPLINKS_SUCCESS = 'FETCHDEEPLINKS_SUCCESS';
export const FETCHVOTINGQUESTIONS = 'FETCHVOTINGQUESTIONS';
export const FETCHVOTINGQUESTIONS_SUCCESS = 'FETCHVOTINGQUESTIONS_SUCCESS';
export const FETCHPOLLINGQUESTIONS = 'FETCHPOLLINGQUESTIONS';
export const FETCHPOLLINGQUESTIONS_SUCCESS = 'FETCHPOLLINGQUESTIONS_SUCCESS';
export const FETCHVOTINGANSWERS = 'FETCHVOTINGANSWERS';
export const FETCHVOTINGANSWERS_SUCCESS = 'FETCHVOTINGANSWERS_SUCCESS';
export const FETCHPOLLINGANSWERS = 'FETCHPOLLINGANSWERS';
export const FETCHPOLLINGANSWERS_SUCCESS = 'FETCHPOLLINGANSWERS_SUCCESS';

export const FETCHADVERTISEMENT = 'FETCHADVERTISEMENT';
export const FETCHCOUPON = 'FETCHCOUPON';
export const FETCHVOTING = 'FETCHVOTING';
export const FETCHPOLLING = 'FETCHPOLLING';
export const FETCHDEEPLINK = 'FETCHDEEPLINK';
export const FETCHADVERTISEMENT_SUCCESS = 'FETCHADVERTISEMENT_SUCCESS';
export const FETCHCOUPON_SUCCESS = 'FETCHCOUPON_SUCCESS';
export const FETCHVOTING_SUCCESS = 'FETCHVOTING_SUCCESS';
export const FETCHPOLLING_SUCCESS = 'FETCHPOLLING_SUCCESS';
export const FETCHDEEPLINK_SUCCESS = 'FETCHDEEPLINK_SUCCESS';

export const CREATEADVERTISEMENT = 'CREATEADVERTISEMENT';
export const CREATEADVERTISEMENT_SUCCESS = 'CREATEADVERTISEMENT_SUCCESS';
export const UPDATEADVERTISEMENT = 'UPDATEADVERTISEMENT';
export const UPDATEADVERTISEMENT_SUCCESS = 'UPDATEADVERTISEMENT_SUCCESS';
export const DELETEADVERTISEMENT = 'DELETEADVERTISEMENT';
export const DELETEADVERTISEMENT_SUCCESS = 'DELETEADVERTISEMENT_SUCCESS';
export const CREATECOUPON = 'CREATECOUPON';
export const CREATECOUPON_SUCCESS = 'CREATECOUPON_SUCCESS';
export const UPDATECOUPON = 'UPDATECOUPON';
export const UPDATECOUPON_SUCCESS = 'UPDATECOUPON_SUCCESS';
export const DELETECOUPON = 'DELETECOUPON';
export const DELETECOUPON_SUCCESS = 'DELETECOUPON_SUCCESS';
export const CREATEVOTING = 'CREATEVOTING';
export const CREATEVOTING_SUCCESS = 'CREATEVOTING_SUCCESS';
export const UPDATEVOTING = 'UPDATEVOTING';
export const UPDATEVOTING_SUCCESS = 'UPDATEVOTING_SUCCESS';
export const DELETEVOTING = 'DELETEVOTING';
export const DELETEVOTING_SUCCESS = 'DELETEVOTING_SUCCESS';
export const CREATEPOLLING = 'CREATEPOLLING';
export const CREATEPOLLING_SUCCESS = 'CREATEPOLLING_SUCCESS';
export const UPDATEPOLLING = 'UPDATEPOLLING';
export const UPDATEPOLLING_SUCCESS = 'UPDATEPOLLING_SUCCESS';
export const DELETEPOLLING = 'DELETEPOLLING';
export const DELETEPOLLING_SUCCESS = 'DELETEPOLLING_SUCCESS';
export const CREATEDEEPLINK = 'CREATEDEEPLINK';
export const CREATEDEEPLINK_SUCCESS = 'CREATEDEEPLINK_SUCCESS';
export const UPDATEDEEPLINK = 'UPDATEDEEPLINK';
export const UPDATEDEEPLINK_SUCCESS = 'UPDATEDEEPLINK_SUCCESS';
export const DELETEDEEPLINK = 'DELETEDEEPLINK';
export const DELETEDEEPLINK_SUCCESS = 'DELETEDEEPLINK_SUCCESS';

// Application
export const FETCHAPPLICATIONS = 'FETCHAPPLICATIONS';
export const FETCHAPPLICATIONS_SUCCESS = 'FETCHAPPLICATIONS_SUCCESS';
export const FETCHAPPLICATION = 'FETCHAPPLICATION';
export const FETCHAPPLICATION_SUCCESS = 'FETCHAPPLICATION_SUCCESS';
export const CHANGEAPPLICATION = 'CHANGEAPPLICATION';
export const FETCHCUSTOMERS = 'FETCHCUSTOMERS';
export const FETCHCUSTOMERS_SUCCESS = 'FETCHCUSTOMERS_SUCCESS';
export const FETCHCUSTOMERINFO = 'FETCHCUSTOMERINFO';
export const FETCHCUSTOMERINFO_SUCCESS = 'FETCHCUSTOMERINFO_SUCCESS';

// Model
export const FETCHMODELS = 'FETCHMODELS';
export const FETCHMODELS_SUCCESS = 'FETCHMODELS_SUCCESS';

// Minisite Editor
export const SELECTMINISITEEDITORCONTENT = 'SELECTMINISITEEDITORCONTENT';
export const ADDMINISITEEDITORCONTENT = 'ADDMINISITEEDITORCONTENT';
export const EDITMINISITEEDITORCONTENT = 'EDITMINISITEEDITORCONTENT';
export const MOVEUPMINISITEEDITORCONTENT = 'MOVEUPMINISITEEDITORCONTENT';
export const MOVEDOWNMINISITEEDITORCONTENT = 'MOVEDOWNMINISITEEDITORCONTENT';
export const REMOVEMINISITEEDITORCONTENT = 'REMOVEMINISITEEDITORCONTENT';
export const DELETEAPPLICATION = 'DELETEAPPLICATION';
export const DELETEAPPLICATION_SUCCESS = 'DELETEAPPLICATION_SUCCESS';

// Event
export const FETCHEVENTS = 'FETCHEVENTS';
export const FETCHEVENTS_SUCCESS = 'FETCHEVENTS_SUCCESS';
export const CREATEEVENT = 'CREATEEVENT';
export const CREATEEVENT_SUCCESS = 'CREATEEVENT_SUCCESS';
export const UPDATEEVENT = 'UPDATEEVENT';
export const UPDATEEVENT_SUCCESS = 'UPDATEEVENT_SUCCESS';
export const DELETEEVENT = 'DELETEEVENT';
export const DELETEEVENT_SUCCESS = 'DELETEEVENT_SUCCESS';

// Logs
export const FETCHSYSLOGS = 'FETCHSYSLOGS';
export const FETCHSYSLOGS_SUCCESS = 'FETCHSYSLOGS_SUCCESS';

// Zone
export const FETCHZONES = 'FETCHZONES';
export const FETCHZONES_SUCCESS = 'FETCHZONES_SUCCESS';
export const CREATEZONE = 'CREATEZONE';
export const CREATEZONE_SUCCESS = 'CREATEZONE_SUCCESS';
export const UPDATEZONE = 'UPDATEZONE';
export const UPDATEZONE_SUCCESS = 'UPDATEZONE_SUCCESS';
export const DELETEZONE = 'DELETEZONE';
export const DELETEZONE_SUCCESS = 'DELETEZONE_SUCCESS';

// User Pool Client
export const FETCHUSERPOOLCLIENTS = 'FETCHUSERPOOLCLIENTS';
export const FETCHUSERPOOLCLIENTS_SUCCESS = 'FETCHUSERPOOLCLIENTS_SUCCESS';
export const CREATEUSERPOOLCLIENT = 'CREATEUSERPOOLCLIENT';
export const CREATEUSERPOOLCLIENT_SUCCESS = 'CREATEUSERPOOLCLIENT_SUCCESS';
export const UPDATEUSERPOOLCLIENT = 'UPDATEUSERPOOLCLIENT';
export const UPDATEUSERPOOLCLIENT_SUCCESS = 'UPDATEUSERPOOLCLIENT_SUCCESS';
export const DELETEUSERPOOLCLIENT = 'DELETEUSERPOOLCLIENT';
export const DELETEUSERPOOLCLIENT_SUCCESS = 'DELETEUSERPOOLCLIENT_SUCCESS';

// Device Batch
export const FETCHDEVICEBATCH = 'FETCHDEVICEBATCH';
export const FETCHDEVICEBATCH_SUCCESS = 'FETCHDEVICEBATCH_SUCCESS';
export const FETCHDEVICEBATCHS = 'FETCHDEVICEBATCHS';
export const FETCHDEVICEBATCHS_SUCCESS = 'FETCHDEVICEBATCHS_SUCCESS';
export const CREATEDEVICEBATCH = 'CREATEDEVICEBATCH';
export const CREATEDEVICEBATCH_SUCCESS = 'CREATEDEVICEBATCH_SUCCESS';
export const UPDATEDEVICEBATCH = 'UPDATEDEVICEBATCH';
export const UPDATEDEVICEBATCH_SUCCESS = 'UPDATEDEVICEBATCH_SUCCESS';
export const DELETEDEVICEBATCH = 'DELETEDEVICEBATCH';
export const DELETEDEVICEBATCH_SUCCESS = 'DELETEDEVICEBATCH_SUCCESS';
export const ONBOARDDEVICEBATCH = 'ONBOARDDEVICEBATCH';
export const ONBOARDDEVICEBATCH_SUCCESS = 'ONBOARDDEVICEBATCH_SUCCESS';

// Mesh Network
export const FETCHMESHNETWORK = 'FETCHMESHNETWORK';
export const FETCHMESHNETWORK_SUCCESS = 'FETCHMESHNETWORK_SUCCESS';
export const FETCHMESHNETWORKS = 'FETCHMESHNETWORK';
export const FETCHMESHNETWORKS_SUCCESS = 'FETCHMESHNETWORK_SUCCESS';
export const CREATEMESHNETWORK = 'CREATEMESHNETWORK';
export const CREATEMESHNETWORK_SUCCESS = 'CREATEMESHNETWORK_SUCCESS';
export const UPDATEMESHNETWORK = 'UPDATEMESHNETWORK';
export const UPDATEMESHNETWORK_SUCCESS = 'UPDATEMESHNETWORK_SUCCESS';
export const DELETEMESHNETWORK = 'DELETEMESHNETWORK';
export const DELETEMESHNETWORK_SUCCESS = 'DELETEMESHNETWORK_SUCCESS';

// Mesh Application
export const CREATEMESHAPPLICATION = 'CREATEMESHAPPLICATION';
export const CREATEMESHAPPLICATION_SUCCESS = 'CREATEMESHAPPLICATION_SUCCESS';
export const UPDATEMESHAPPLICATION = 'UPDATEMESHAPPLICATION';
export const UPDATEMESHAPPLICATION_SUCCESS = 'UPDATEMESHAPPLICATION_SUCCESS';
export const DELETEMESHAPPLICATION = 'DELETEMESHAPPLICATION';
export const DELETEMESHAPPLICATION_SUCCESS = 'DELETEMESHAPPLICATION_SUCCESS';


// Mesh Action
export const MESHDISCOVERUNPROVISIONED = 'MESHDISCOVERUNPROVISIONED';
export const MESHDISCOVERUNPROVISIONED_SUCCESS = 'MESHDISCOVERUNPROVISIONED_SUCCESS';
export const MESHPROVISION = 'MESHPROVISION';
export const MESHPROVISION_SUCCESS = 'MESHPROVISION_SUCCESS';
export const MESHGET = 'MESHGET';
export const MESHGET_SUCCESS = 'MESHGET_SUCCESS';
export const MESHSET = 'MESHSET';
export const MESHSET_SUCCESS = 'MESHSET_SUCCESS';
export const DESCRIBEJOBEXECUTION = 'DESCRIBEJOBEXECUTION';
export const DESCRIBEJOBEXECUTION_SUCCESS = 'DESCRIBEJOBEXECUTION_SUCCESS';

// WebSocket
export const INITWEBSOCKET = 'INITWEBSOCKET';
export const NOTIFICATION_NEW = 'NOTIFICATION_NEW';
export const READNOTIFICATION = 'READNOTIFICATION';
